import "./App.css";
import NavBar from "./components/NavBar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./components/footer/Footer";
import UserInfo from "./pages/userinfo/UserInfo";
import Profiles from "./pages/profiles/Profiles";
import AddBeneficiary from "./pages/addbeneficiary/AddBeneficiary";
import ClaimsDecleration from "./pages/claimsdecleration/ClaimsDecleration";
import About from "./pages/about/About";
import Faq from "./pages/faq/Faq";
import TermeEtConditions from "./pages/TermsAndCondition/TermsAndCondition";
import ContactUs from "./pages/contactus/ContactUs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Authentication from "./tools/ProtectedComponent";
import Claims from "./pages/claimsdecleration/Claims";
import Hme from "./pages/hme/Hme";
import Beneficiary from "./pages/addbeneficiary/Beneficiary";
import LanguageSwitcher from "./components/languageswitch/LanguageSwitcher";
import Subscription from "./pages/addSubAccount/Subscription";
import AccountPage from "./pages/addbeneficiary/AccountPage";
import InsuredPage from "./pages/addbeneficiary/InsuredPage";
import HistoriqueTransaction from "./pages/addbeneficiary/HistoriqueTransaction";
import DescriptionSavingPlan from "./pages/descriptionSavingPlan/DescriptionSavingPlan";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import NotFound from "./pages/notFound/notFound";
function App() {
  const dispatch = useDispatch();
  const expiration = useSelector((state) => state.users.expiration);

  useEffect(() => {
    if (!expiration) return;

    const checkTokenExpiration = () => {
      const currentTime = new Date().getTime();
      // Parser le format 'YYYY-MM-DD HH:mm:ss'
      const expirationTime = new Date(expiration.replace(" ", "T")).getTime();

      if (currentTime >= expirationTime) {
        dispatch({ type: "LOGOUT" });
        toast.info("Votre session a expiré. Veuillez vous reconnecter.");
      }
    };

    // Vérifier immédiatement et ensuite toutes les 30 secondes
    checkTokenExpiration();
    const interval = setInterval(checkTokenExpiration, 30000);

    return () => clearInterval(interval);
  }, [expiration, dispatch]);

  return (
    <>
      <ToastContainer />
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" exact Component={Hme} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/nosProduits" element={<DescriptionSavingPlan />} />
          <Route
            path="/viewuserinfo"
            element={<Authentication protectedComponent={UserInfo} />}
          />
          <Route
            path="/profiles"
            element={<Authentication protectedComponent={Profiles} />}
          />
          <Route
            path="/addbeneficiary"
            element={<Authentication protectedComponent={AddBeneficiary} />}
          />
          <Route path="/declaration" element={<ClaimsDecleration />} />
          <Route
            path="/mon-compte"
            element={<Authentication protectedComponent={AccountPage} />}
          />
          <Route
            // path="/assuré"
            path="/assure"
            element={<Authentication protectedComponent={InsuredPage} />}
          />
          <Route
            path="/mes-historiques"
            element={
              <Authentication protectedComponent={HistoriqueTransaction} />
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          {/* <Route path="/contact" element={<ContactUs />} /> */}
          <Route path="/tec" element={<TermeEtConditions />} />
          <Route path="/claims" element={<Authentication protectedComponent={Claims} />} />
          <Route path="/hme" element={<Hme />} />
          <Route
            path="/beneficiary"
            element={<Authentication protectedComponent={Beneficiary} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <LanguageSwitcher />
        <Footer />
      </Router>
    </>
  );
}

export default App;
